// src/types/proyectos/raceway.ts

// ─── Phase ────────────────────────────────────────────────────────────────────

export interface PhaseStatus {
  name: string;
  active: boolean;
}

// ─── Tank Snapshot (matches WS payload exactly) ───────────────────────────────

export interface TankSnapshot {
  name: string;
  level: number;
  state: string;
  /** null for tanks that don't support auto-control (cultivo, cosecha) */
  auto_control: boolean | null;
  current_phase: string | null;
  busy: boolean;
  /** null for tanks without drain sensor (cultivo, cosecha) */
  sensor_drain: boolean | null;
  sensor_max: boolean;
  /** null for tanks without min sensor (cosecha) */
  sensor_min: boolean | null;
  phases: PhaseStatus[];
}

// ─── Valve State ──────────────────────────────────────────────────────────────

export interface ValveState {
  addr: number;
  open: boolean;
}

// ─── Main Estado (matches WS payload structure) ───────────────────────────────

export interface Estado {
  tanks: {
    dep_raceway: TankSnapshot;
    dep_cultivo: TankSnapshot;
    dep_cosecha: TankSnapshot;
  };
  valves: ValveState[];
}

// ─── Valve Address Map ────────────────────────────────────────────────────────

/** Canonical valve address → UI id mapping */
export const VALVE_ADDR = {
  V1_FILL_RACEWAY:     16,
  V2_FILL_CULTIVO:     17,
  V3_GAS_CULTIVO:      18,
  V4_TRANSFER_RACEWAY: 19,
  V5_DRAIN_CULTIVO:    20,
  V6_FILL_COSECHA:     21,
} as const;

/** Look up an open/close state from the valves array by address */
export function getValveOpen(valves: ValveState[] | undefined, addr: number): boolean {
  if (!valves) return false;
  return valves.find(v => v.addr === addr)?.open ?? false;
}

// ─── Time Settings ────────────────────────────────────────────────────────────

export interface TimeSettings {
  dep_raceway: {
    llenado: number;
    vaciado: number;
  };
  dep_cultivo: {
    llenado: number;
    vaciado: number;
    gases_cultivo: number;
    volcar_raceway: number;
  };
  dep_cosecha: {
    llenado: number;
  };
}

// ─── UI-only types ────────────────────────────────────────────────────────────

export type FuncionOverview = {
  id: number;
  titulo: string;
  utilidad: string;
  aplicaciones: string[];
  icono: string;
  gradiente: string;
  acento: string;
  tag: string;
};

export type StatItem = {
  valor: string;
  label: string;
};

export type NivelItem = {
  label: string;
  nivel: number;
  color: string;
};

export type MetricFileName =
  | 'detailed_df_t.json'
  | 'detailed_df_t1_ext.json'
  | 'detailed_df_t1.json';